<span [title]="getSearchOperatorTitle(operator)">
	<span class="screen-reader-text">{{ operator }}</span>
	<i aria-hidden="true" class="{{ getIconClasses() }}" [ngClass]="class"></i>
</span>
